export default "__VITE_ASSET__bnmtZl3a__"